import { ACCOUNT_PERMISSIONS } from '@/store/account-permissions'

/**
 * Takes billing data out of the store the moment the member stops being allowed to see it.
 *
 * The permission can go while the page is open: the member's own role was changed, or another admin
 * changed it and the permissions were re-read (see services/permissionRefresh.js). Everything
 * loaded under the old permission - the balance, the summary, payments, cards, bank details - is
 * still in the store then, and nothing would ever remove it: the gated pages stop being reachable,
 * but a stale amount in the state is one `mapState` away from being shown.
 *
 * Only the loss is watched. Gaining billing needs nothing here - the components that show billing
 * data load it when they are opened.
 */
export default function billingAccessPlugin(store) {
  store.watch(
    (state, getters) => getters['auth/hasPermission'](ACCOUNT_PERMISSIONS.BILLING),
    (hasBilling, hadBilling) => {
      if (hadBilling && !hasBilling) {
        store.dispatch('billing/revokeBillingData')
      }
    }
  )
}
